import { useStore, create } from "zustand";
import _isEqual from "lodash.isequal";
import type { Style } from "mapbox-gl";

import { StyleCustomisation } from "./types";

interface MapStyleStore {
  baseMapStyle: null | Style;
  customisations: StyleCustomisation[];
  setBaseMapStyle: (baseMapStyle: Style | null) => void;
  addStyleCustomisations: (styleCustomisations: StyleCustomisation[]) => void;
  removeStyleCustomisations: (
    styleCustomisations: StyleCustomisation[]
  ) => void;
}

const mapStyleStore = create<MapStyleStore>()((set) => ({
  baseMapStyle: null,
  customisations: [],
  setBaseMapStyle: (nextBaseMapStyle: Style | null) =>
    set((state) => {
      if (!_isEqual(nextBaseMapStyle, state.baseMapStyle)) {
        return { baseMapStyle: nextBaseMapStyle };
      }

      return state;
    }),
  addStyleCustomisations: (styleCustomisations: StyleCustomisation[]) =>
    set((state) => ({
      customisations: state.customisations.concat(styleCustomisations),
    })),
  removeStyleCustomisations: (styleCustomisations: StyleCustomisation[]) =>
    set((state) => ({
      customisations: state.customisations.filter(
        (customisation) => styleCustomisations.indexOf(customisation) === -1
      ),
    })),
}));

function useMapStateStore(): MapStyleStore;
function useMapStateStore<T>(
  selector: (state: MapStyleStore) => T,
  equals?: (a: T, b: T) => boolean
): T;
function useMapStateStore<T>(
  selector?: (state: MapStyleStore) => T,
  equals?: (a: T, b: T) => boolean
) {
  return useStore(mapStyleStore, selector!, equals);
}

export default useMapStateStore;
